import { render, staticRenderFns } from "./bidManage.vue?vue&type=template&id=6dbc5a1b&scoped=true&"
import script from "./bidManage.vue?vue&type=script&lang=js&"
export * from "./bidManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc5a1b",
  null
  
)

export default component.exports